<template>
  <div class="smile">
    <video loop playsinline muted preload="none" ref=video>
      <source ref="source" type="video/mp4" poster="../assets/smile-placeholder-m.jpg">
    </video>

  </div>
</template>

<script>
  export default {
    name: 'smile',
    mounted() {
      this.screenSize = '';
      this.setVideoSrc();
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.setVideoSrc);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.setVideoSrc);
    },
    methods: {
      checkWidth(){
        if (window.innerWidth < 768){
          return 'mobile';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024){ 
          return 'tablet';
        } else {
          return 'desktop'
        }
      },
      setVideoSrc(){
        
        let screenSize = this.checkWidth();

        // return if no breakpoint is crossed
        if (screenSize === this.screenSize) return;

        if (screenSize === 'mobile'){
          this.screenSize = 'mobile';
          this.$refs.source.setAttribute('src', 'static/videos/smiles-mobile.mp4');
          this.$refs.video.load();
        } else if (screenSize === 'tablet'){ 
          this.screenSize = 'tablet';
          this.$refs.source.setAttribute('src', 'static/videos/smiles-tablet.mp4');
          this.$refs.video.load();
        } else {
          this.screenSize = 'desktop';
          this.$refs.source.setAttribute('src', 'static/videos/smiles-desktop.mp4');
          this.$refs.video.load();
        }
      },
      isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
          rect.bottom >= 0 &&
          rect.top <= (window.innerHeight || html.clientHeight)
        );
      },
      handleScroll() {
        const video = this.$refs.video;

        if (this.isInViewport(video)){
          video.play();
        
        } else {
          var isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
          if (isPlaying) {
            video.pause();
          }
        }
      } 
    }
  };
</script>

<style lang='scss' scoped>
  @import './../variables';

  .smile {
  	font-size: 0;
    background: #009FDE; //prevent flash of white at bottom when scaling
    video {
      width: 100%;
    }
  }

 </style>



// WEBPACK FOOTER //
// src/components/Smile.vue